import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { formatNumbers, newFormatPrice } from '../../../../services/utilityFunctions';

function ProgressChart({ t, target: targetObj, unityType }) {
  const { points, progress, target, unity, currency } = targetObj;
  // Check if progress is negative
  const isNegative = progress < 0;

  // We're removing PI/2 from the circle, 25%, so instead of using percentages, we use per 75
  const progressPercentage = progress ? progress * 100 : 0;

  const per75 = progress
    ? progressPercentage * 0.75
    : 0;

  const infoUnity = unityType;

  // Setting up progress path
  let dashToUse = `${per75}, 75`;
  let backgroundClass = 'best-day-graph-background';
  let contentPathClass = 'best-day-graph-path';
  if (isNegative) {
    dashToUse = `${75 + per75}, 75`;
    backgroundClass = 'best-day-graph-background-negative';
    contentPathClass = 'best-day-graph-path-negative';
  }

  // format value either currency, either other type of unity
  const valueToUse = (type, number, showUnity = true) => type === 'currency' ?
    newFormatPrice(number, false, currency || 'eur') : `${formatNumbers(number)} ${showUnity ? infoUnity : ''}`;
  return (
    <div className="best-day-container">
      <h4 className="performance-subtitle">{t('perform.performance.target')}</h4>
      <svg viewBox="0 0 36 36" className="best-day-graph">
        <path
          className={backgroundClass}
          strokeDasharray="75, 75"
          d="M6.7460 29.25395
              A 15.9155 15.9155 0 0 1 18 2.0845
              A 15.9155 15.9155 0 0 1 29.25395 29.25395"
        />
        <path
          className={contentPathClass}
          strokeDasharray={dashToUse}
          d="M6.7460 29.25395
              A 15.9155 15.9155 0 0 1 18 2.0845
              A 15.9155 15.9155 0 0 1 29.25395 29.25395"
        />
      </svg>
      <br />
      <div className="target-info-container">
        <div className="row">
          {target > 0 &&
            <div className="info-target col-lg-12 col-12">
              {`${t('perform.performance.target')}: ${valueToUse(unity, target)}`}
            </div>
          }
        </div>
        <div className="row">
          {(points !== undefined && points !== null) &&
            <div className="info-score col-lg-12 col-12">
              {`${t('perform.performance.scored')}: ${valueToUse(unity, points)}`}
            </div>
          }
        </div>
      </div>
      <div className="best-day-points">
        <span className={isNegative ? 'negative' : 'positive'}>
          {`${valueToUse('percentage', progressPercentage, false)} %`}
        </span>
      </div>
    </div>
  );
}

ProgressChart.propTypes = {
  t: PropTypes.func.isRequired,
  target: PropTypes.shape({
    target: 0,
    progress: 0,
    points: 0,
    unity: PropTypes.string,
    currency: PropTypes.string,
  }),
  unityType: PropTypes.string.isRequired,
};

ProgressChart.defaultProps = {
  target: {},
};

export default translate(ProgressChart);
